var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "label",
    { staticClass: "block font-medium text-sm text-gray-700" },
    [
      _vm.value
        ? _c("span", [_vm._v(_vm._s(_vm.value))])
        : _c("span", [_vm._t("default")], 2),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }